import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Whychoose(props) {
    return (
        <section className=" p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Services AZURE">
                            <h2>TekRevol’s Microsoft Azure Consulting Services</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>TekRevol leading full-cycle and standalone offerings in the Microsoft Azure cloud start with a comprehensive audit. Here what you get when you partner with TekRevol for Azure Migration and Implementation.Full-cycle Microsoft azure consultancy with a needs assessment.Post-deployment Azure cloud performance and cost auditlisting_points.Product and solutions development on Microsoft Azure.Microsoft Azure cloud migration and implementation.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Whychoose;